interface WebSocketToggleSectionProps {
  isEnabled: boolean;
  isConnected: boolean;
  connectionState: string;
  retainedDataCount: number;
  onToggle: () => void;
}

/**
 * WebSocket Toggle Section Component
 * Displays WebSocket connection controls and status
 */
export default function WebSocketToggleSection({
  isEnabled,
  isConnected,
  connectionState,
  retainedDataCount,
  onToggle,
}: WebSocketToggleSectionProps) {
  return (
    <div className="App-section hooks-test-websocket-section">
      <div className="hooks-test-websocket-controls">
        <button
          onClick={onToggle}
          className={`hooks-test-websocket-button ${
            isEnabled
              ? "hooks-test-websocket-button-enabled"
              : "hooks-test-websocket-button-disabled"
          }`}
        >
          {isEnabled ? "Disable" : "Enable"} Connect WebSocket
        </button>
        <span
          className={`hooks-test-connection-status ${
            isEnabled
              ? "hooks-test-connection-status-enabled"
              : "hooks-test-connection-status-disabled"
          } ${
            isConnected
              ? "hooks-test-connection-status-connected"
              : "hooks-test-connection-status-disconnected"
          }`}
        >
          {isConnected ? "● Connected" : "○ Disconnected"} ({connectionState})
        </span>
      </div>
      {isEnabled && (
        <div className="hooks-test-websocket-info">
          WebSocket is enabled. Hooks will receive real-time updates via
          multi-feed channel.
          {retainedDataCount > 0 && (
            <span className="hooks-test-retained-data-info">
              Retained data: {retainedDataCount} sub-channels
            </span>
          )}
        </div>
      )}
    </div>
  );
}
